import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

// Client age/experience and other driver (CASCO) age/experience mirror each other:
// when one side is filled in and the other is empty, the empty one is pre-filled
export const DRIVER_DATA_COUNTERPARTS: Record<string, string> = {
  "clientData.clientAge": "vehicleData.otherDriverAge",
  "clientData.drivingExperience": "vehicleData.otherDriverExperience",
  "vehicleData.otherDriverAge": "clientData.clientAge",
  "vehicleData.otherDriverExperience": "clientData.drivingExperience",
};

const isBlank = (value: unknown): boolean =>
  value === null ||
  value === undefined ||
  (typeof value === "string" && value.trim() === "");

/**
 * Returns a handler that copies the value of the given field into its
 * counterpart (see DRIVER_DATA_COUNTERPARTS) if the counterpart is empty.
 */
export const useDriverDataSync = () => {
  const { getValues, setValue } = useFormContext();

  return useCallback(
    (sourceField: string) => {
      const targetField = DRIVER_DATA_COUNTERPARTS[sourceField];
      if (!targetField) return;

      const value = getValues(sourceField);
      if (isBlank(value) || !isBlank(getValues(targetField))) return;

      setValue(targetField, value, { shouldDirty: true });
    },
    [getValues, setValue]
  );
};
